export default {
  namespaced: true,
  state: {
    activeCancelChart: 'prison',
    activeBusiestChart: 'past',
  },
  getters: {
    // getKioskEnabled(state){
    //   return state.kioskEnabled;
    // },
  },
  mutations: {
    SET_ACTIVE_CANCEL_CHART(state, value){
      state.activeCancelChart = value;
    },
    SET_ACTIVE_BUSIEST_CHART(state, value){
      state.activeBusiestChart = value;
    },
  },
  actions: {

  }
};
